import { render, staticRenderFns } from "./TournamentSettingsForm.vue?vue&type=template&id=0e941d02&scoped=true"
import script from "./TournamentSettingsForm.vue?vue&type=script&lang=js"
export * from "./TournamentSettingsForm.vue?vue&type=script&lang=js"
import style0 from "./TournamentSettingsForm.vue?vue&type=style&index=0&id=0e941d02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e941d02",
  null
  
)

export default component.exports